import { AdjustInstructions, AdjustToolRow } from './AdjustToolsPanel.component'
import { LabSubscribeButton, LabSubscribersOnlyCard } from '../lab/LabSubscribe.component'

import { ADJUST_PANEL_TOOLS } from './adjust.types'
import { EditionType } from '../photoStudioTypes'
import { FC } from 'react'
import { LabPanelShell } from '../lab/LabPanelPrimitives.component'
import { Stack } from '@mui/material'

/**
 * Adjust for non-subscribers on the Lab engine: the in-house editor's tools, locked, whichever Adjust editor is on —
 * the list a subscriber gets (Blur has its own locked panel, `BlurPanel`). In the Combine tools list (`embedded`) the
 * list alone: that view has its own card and Subscribe CTA.
 */
export const AdjustLockedPanel: FC<{ embedded?: boolean }> = ({ embedded = false }) => {
  const tools = (
    <Stack gap="0.8rem">

      <AdjustInstructions />

      {ADJUST_PANEL_TOOLS.map((tool) => <AdjustToolRow key={tool.id} tool={tool} isOpen={false} disabled onToggle={() => undefined} />)}

    </Stack>
  )

  return (
    <>

      {embedded && tools}

      {!embedded && (
        <LabPanelShell footer={<LabSubscribeButton editionType={EditionType.ADJUST} />}>

          <LabSubscribersOnlyCard margin="0 0 2.4rem" />

          {tools}

        </LabPanelShell>
      )}

    </>
  )
}
